/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventRendererQueryVariables = {
    orgRelayId: string;
    externalEventId: string;
    externalEventIds: Array<string>;
    calendarId: string;
    calendarIds: Array<string>;
    isLinkedSmartHold: boolean;
    isOnAPHistory: boolean;
};
export type EventRendererQueryResponse = {
    readonly org: {
        readonly __typename: string;
        readonly id: string;
        readonly name?: string | null | undefined;
        readonly domains?: ReadonlyArray<string | null> | null | undefined;
        readonly canScheduleResponse?: ({
            readonly __typename: "CanScheduleResponseList";
            readonly list: ReadonlyArray<{
                readonly canAutopilot: boolean;
                readonly canReschedule: boolean;
                readonly attendeeNotInDomain: boolean;
                readonly organizerNotClockwiseUser: boolean;
                readonly isAllDayEvent: boolean;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
        readonly crawledCalendarInfoForCalendars?: {
            readonly none: ReadonlyArray<string | null> | null;
            readonly pending: ReadonlyArray<string | null> | null;
            readonly synced: ReadonlyArray<string | null> | null;
            readonly stale: ReadonlyArray<string | null> | null;
        } | null | undefined;
        readonly smartHoldEventInfo?: {
            readonly __typename: "SmartHoldEventInfo";
            readonly " $fragmentRefs": FragmentRefs<"Event_smartHoldEventInfo">;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
        readonly shadowCalendarSettingsErrorable?: {
            readonly __typename: "ShadowCalendarSettings";
            readonly enabled: boolean;
            readonly shadowCalendarId: string | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
        readonly forceFetchEventParentErrorable?: {
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
        } | {
            readonly __typename: "EventParent";
            readonly id: string;
            readonly events: ReadonlyArray<{
                readonly eventKey: {
                    readonly externalEventId: string;
                };
                readonly calendarIds: ReadonlyArray<string>;
                readonly annotatedEvent: {
                    readonly orgTags: ReadonlyArray<{
                        readonly state: {
                            readonly value: string | null;
                            readonly active: boolean;
                        };
                    }> | null;
                } | null;
            }>;
            readonly " $fragmentRefs": FragmentRefs<"Event_eventParent">;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
        readonly " $fragmentRefs": FragmentRefs<"Event_org" | "PainOrPriorityEvent_org">;
    } | null;
    readonly viewer: {
        readonly user: {
            readonly " $fragmentRefs": FragmentRefs<"Event_user">;
        } | null;
    };
};
export type EventRendererQuery = {
    readonly response: EventRendererQueryResponse;
    readonly variables: EventRendererQueryVariables;
};



/*
query EventRendererQuery(
  $orgRelayId: ID!
  $externalEventId: String!
  $externalEventIds: [String!]!
  $calendarId: String!
  $calendarIds: [String!]!
  $isLinkedSmartHold: Boolean!
) {
  org: node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      name
      domains
      ...Event_org
      ...PainOrPriorityEvent_org
      canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $calendarIds) {
        __typename
        ... on CanScheduleResponseList {
          list {
            canAutopilot
            canReschedule
            attendeeNotInDomain
            organizerNotClockwiseUser
            isAllDayEvent
          }
        }
      }
      crawledCalendarInfoForCalendars(calendarIds: $calendarIds) {
        none
        pending
        synced
        stale
        id
      }
      smartHoldEventInfo(externalEventId: $externalEventId) @include(if: $isLinkedSmartHold) {
        __typename
        ... on SmartHoldEventInfo {
          ...Event_smartHoldEventInfo
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
      shadowCalendarSettingsErrorable {
        __typename
        ... on ShadowCalendarSettings {
          enabled
          shadowCalendarId
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
      forceFetchEventParentErrorable(calendarId: $calendarId, externalEventId: $externalEventId) {
        __typename
        ... on GraphEntityError {
          statusCode
        }
        ... on EventParent {
          id
          ...Event_eventParent_2wMSFq
          events {
            eventKey {
              externalEventId
              id
            }
            calendarIds
            annotatedEvent {
              orgTags {
                state {
                  value
                  active
                }
              }
              id
            }
          }
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
    }
  }
  viewer {
    user {
      ...Event_user
      id
    }
    id
  }
}

fragment AutopilotEventHistory_event_3GsBW on Event {
  eventAutopilotHistory {
    __typename
    ... on EventAutopilotHistory {
      status
      actions {
        actionType
        actionString
        actionInfo
        timestamp
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  eventKey {
    externalEventId
    id
  }
  organizer {
    urnValue
  }
  title
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  startTime {
    dateOrDateTime
  }
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment AutopilotFlexibility_event on Event {
  eventParentRelayId
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
  }
  eventKey {
    id
    externalEventId
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFlexibility_org on Org {
  userWorkingHours(resolveOverrides: false) {
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
    id
  }
}

fragment AutopilotFormSaveOnEdit_eventParent on EventParent {
  id
  externalEventId
}

fragment AutopilotFormSaveOnEdit_event_3GsBW on Event {
  ...AutopilotForm_event_3GsBW
  title
  isAllDay
  locked
  eventKey {
    externalEventId
    id
  }
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  startTime {
    dateOrDateTime
    millis
  }
  organizer {
    urnValue
  }
  attendees {
    displayName
    urnValue
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFormSaveOnEdit_org on Org {
  ...AutopilotForm_org
  id
  experiments
  personsByUserIdsErrorable(userIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFormSaveOnEdit_org_2evVr4 on Org {
  ...AutopilotForm_org
  id
  experiments
  personsByUserIdsErrorable(userIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFormSaveOnEdit_user on User {
  emails
  webAppFlagsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Flags {
      flags
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment AutopilotForm_event_3GsBW on Event {
  ...AutopilotFlexibility_event
  ...OrganizerAutopilotPausedFreemiumCallout_event
  eventParentRelayId
  eventKey {
    id
    externalEventId
  }
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
        moveRangesEnabled
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment AutopilotForm_org on Org {
  ...AutopilotFlexibility_org
  ...OrganizerAutopilotPausedFreemiumCallout_org
  id
  experiments
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  pendingInvites(first: 1000000) {
    edges {
      node {
        targetCalendarId
        id
      }
    }
  }
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment EventPeople_event on Event {
  organizer {
    urnValue
  }
  attendees {
    organizer
    urnValue
    responseStatus
  }
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        __typename
        id
        emails
        primaryEmail
        isYou
        userId
        isUser
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
  }
}

fragment EventPersonalCalendarInfo_eventParent_3GsBW on EventParent {
  id
  externalEventId
  syncedOriginEventErrorable {
    __typename
    ... on Event {
      __typename
      title
    }
    ... on GraphEntityError {
      __typename
      statusCode
      message
    }
  }
}

fragment EventSmartHoldInfo_event_3GsBW on Event {
  ...EventSummary_event_3GsBW
  title
  isClockwiseEvent
  organizer {
    urnValue
  }
  eventKey {
    externalEventId
    id
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        subjectType
        subjectValue
        value
        active
      }
    }
    id
  }
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
}

fragment EventSmartHoldInfo_org on Org {
  ...EventSummary_org
  id
  primaryOrgCalendar
  primaryOrgEmail
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      shadowCalendarId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventSmartHoldInfo_smartHoldEventInfo on SmartHoldEventInfo {
  isPreTravelTime
  isPostTravelTime
  isMeetingPrep
  originEvent {
    title
    eventKey {
      externalEventId
      id
    }
    annotatedEvent {
      userTags {
        tag
        states {
          subjectType
          subjectValue
          value
        }
      }
      id
    }
  }
}

fragment EventSmartHoldInfo_user on User {
  ...EventSummary_user
}

fragment EventSummaryAutopilot_event_3GsBW on Event {
  autopilotEventStatus(calendarId: $calendarId) {
    __typename
    ... on AutopilotEventStatus {
      status
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
        moveRangesEnabled
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment EventSummaryAutopilot_org on Org {
  id
  experiments
}

fragment EventSummaryColorCategory_event on Event {
  title
  isClockwiseEvent
  transparency
  isAllDay
  eventKey {
    id
    externalEventId
    orgId
  }
  annotatedEvent {
    userTags {
      tag
      states {
        value
        subjectType
        subjectValue
        lastModified
        active
      }
    }
    orgTags {
      tag
      state {
        value
        subjectType
        subjectValue
        lastModified
        active
      }
    }
    id
  }
}

fragment EventSummaryColorCategory_org on Org {
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      shadowCalendarId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  id
  experiments
  eventColoringSettingsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on EventColoringSettings {
      eventCategoryColorings {
        googleColorKey
        eventCategory
        active
        isUserSet
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventSummaryColorCategory_user on User {
  id
  webAppFlagsErrorable {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Flags {
      flags
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventSummaryRecurrence_event on Event {
  isAllDay
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryRecurrence_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummaryRoom_attendees on Attendee {
  displayName
  urnValue
}

fragment EventSummaryTime_event on Event {
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryTime_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummary_eventParent on EventParent {
  ...AutopilotFormSaveOnEdit_eventParent
}

fragment EventSummary_event_3GsBW on Event {
  ...EventSummaryColorCategory_event
  ...EventSummaryRecurrence_event
  ...EventSummaryTime_event
  ...EventSummaryAutopilot_event_3GsBW
  ...EventTimeAndRecurrence_event
  ...AutopilotFormSaveOnEdit_event_3GsBW
  title
  isAllDay
  description
  descriptionOmitted
  locked
  isClockwiseEvent
  createdMillis
  updatedMillis
  hangoutLink
  scrubbedEvent
  organizer {
    urnValue
  }
  eventKey {
    externalEventId
    id
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        subjectType
        subjectValue
        value
        active
      }
    }
    id
  }
  attendees {
    ...EventSummaryRoom_attendees
    organizer
    displayName
    urnValue
  }
  startTime {
    millis
  }
  endTime {
    millis
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
}

fragment EventSummary_org on Org {
  ...EventSummaryAutopilot_org
  ...EventSummaryColorCategory_org
  ...EventSummaryRecurrence_org
  ...EventSummaryTime_org
  ...EventTimeAndRecurrence_org
  ...AutopilotFormSaveOnEdit_org_2evVr4
  id
  experiments
  primaryOrgCalendar
  nextDefragTime {
    __typename
    ... on DefragTime {
      millis
    }
  }
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      focusTimeSyncAll
      focusTimeIdealMinutesPerWeek
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamCalendarId
        teamName
        createdBy {
          value
          id
        }
        teamMembers {
          person {
            __typename
            id
            personId
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        invitedMembers {
          person {
            __typename
            id
            personId
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
      }
    }
  }
  userGoals(first: 1000000) {
    edges {
      node {
        id
        name
        options {
          specificOptions {
            __typename
            ... on GoalWithinWeekOptions {
              maxMinutesPerBlock
            }
            ... on GoalWithinDayOptions {
              minimumDuration
              idealDuration
              minTimeSlot
              maxTimeSlot
            }
          }
        }
      }
    }
  }
}

fragment EventSummary_smartHoldEventInfo on SmartHoldEventInfo {
  isPreTravelTime
  isPostTravelTime
  originEvent {
    title
    eventKey {
      externalEventId
      id
    }
  }
}

fragment EventSummary_user on User {
  ...EventSummaryColorCategory_user
  ...AutopilotFormSaveOnEdit_user
  emails
}

fragment EventTeam_eventParent_3GsBW on EventParent {
  id
  externalEventId
  events {
    ...AutopilotFormSaveOnEdit_event_3GsBW
    ...EventSummary_event_3GsBW
    ...EventSmartHoldInfo_event_3GsBW
    ...EventPeople_event
    ...EventSummaryTime_event
    calendarIds
    isAllDay
    isClockwiseEvent
    locked
    organizerPerson {
      __typename
      ... on Person {
        emails
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    annotatedEvent {
      userTags {
        tag
        states {
          value
          subjectType
          subjectValue
          lastModified
          active
        }
      }
      orgTags {
        tag
        state {
          subjectType
          subjectValue
          value
          active
        }
      }
      id
    }
    eventKey {
      id
      calendarIds
      externalEventId
      hashedCalendars
      orgId
    }
    startTime {
      millis
      dateOrDateTime
      timeZone
    }
    endTime {
      millis
    }
    title
    attendees {
      displayName
      urnValue
    }
    organizer {
      urnValue
    }
  }
}

fragment EventTeam_org on Org {
  id
  ...EventSummaryTime_org
  experiments
  domains
  primaryOrgCalendar
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamCalendarId
        teamName
        createdBy {
          value
          id
        }
        teamMembers {
          person {
            __typename
            id
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        invitedMembers {
          person {
            __typename
            id
            primaryCalendarId
            isYou
            userId
            profile {
              givenName
              familyName
              externalImageUrl
            }
          }
        }
        settings {
          __typename
          ... on TeamSettings {
            manageTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
      }
    }
  }
}

fragment EventTeam_smartHoldEventInfo on SmartHoldEventInfo {
  isTeamCalendarSyncEvent
  originEvent {
    title
    isAllDay
    calendarIds
    eventKey {
      externalEventId
      id
    }
    organizer {
      displayName
      urnValue
    }
    startTime {
      millis
      dateOrDateTime
    }
    endTime {
      millis
      dateOrDateTime
    }
    organizerPerson {
      __typename
      ... on Person {
        __typename
        primaryEmail
        emails
        isYou
        userId
        isUser
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
  }
}

fragment EventTeam_user on User {
  chromeExtensionFlagsErrorable {
    __typename
    ...TutorialTeamSharedCalendar_flagsErrorable
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment EventTimeAndRecurrence_event on Event {
  isAllDay
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventTimeAndRecurrence_org on Org {
  id
  primaryOrgCalendar
}

fragment Event_eventParent_2wMSFq on EventParent {
  id
  externalEventId
  ...EventPersonalCalendarInfo_eventParent_3GsBW
  ...AutopilotFormSaveOnEdit_eventParent
  ...EventTeam_eventParent_3GsBW
  ...EventSummary_eventParent
  syncedOriginEventErrorable {
    __typename
    ... on Event {
      ...EventSummary_event_3GsBW
      title
      description
      descriptionOmitted
      locked
      isAllDay
      isClockwiseEvent
      createdMillis
      updatedMillis
      hangoutLink
      organizer {
        urnValue
      }
      eventKey {
        externalEventId
        id
      }
      annotatedEvent {
        orgTags {
          tag
          state {
            subjectType
            subjectValue
            value
          }
        }
        id
      }
      attendees {
        ...EventSummaryRoom_attendees
        organizer
        displayName
        urnValue
      }
      startTime {
        millis
      }
      endTime {
        millis
      }
      recurrenceRules {
        firstInstanceStartTime {
          type
          dateOrDateTime
          timeZone
          millis
          offsetMinutes
        }
        timeZone
        interval {
          interval
          byDay
          bySetPos
          freqType
          count
          untilTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  events {
    ...AutopilotFormSaveOnEdit_event_3GsBW
    ...EventSummary_event_3GsBW
    ...EventSmartHoldInfo_event_3GsBW
    ...EventPeople_event
    ...AutopilotEventHistory_event_3GsBW
    calendarIds
    isAllDay
    isClockwiseEvent
    locked
    scrubbedEvent
    organizerPerson {
      __typename
      ... on Person {
        emails
        isYou
        primaryEmail
        userId
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    organizerOrgPerson {
      __typename
      ... on OrgPerson {
        isYou
        userId
        personId
        primaryCalendarId
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    annotatedEvent {
      userTags {
        tag
        states {
          value
          subjectType
          subjectValue
          lastModified
          active
        }
      }
      orgTags {
        tag
        state {
          subjectType
          subjectValue
          value
          active
        }
      }
      id
    }
    eventKey {
      id
      calendarIds
      externalEventId
      hashedCalendars
      orgId
    }
    startTime {
      millis
      dateOrDateTime
      timeZone
    }
    endTime {
      millis
    }
    title
    attendees {
      displayName
      urnValue
    }
    organizer {
      urnValue
    }
    attendeePeople {
      __typename
      ... on PersonList {
        list {
          id
          emails
          primaryEmail
          profile {
            givenName
            familyName
            externalImageUrl
          }
          isYou
        }
      }
    }
    recurrenceRules {
      timeZone
    }
    suggestedAutopilotSettingsResponseV3 {
      __typename
      ... on SuggestedAutopilotSettingsResponseV3 {
        intersectionOfAttendeesMeetingHours {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
        calendarIdToMeetingHours {
          calendarId
          dayOffsetTimeSlotRanges {
            minSlot {
              dayOffset
              timeSlot
            }
            maxSlot {
              dayOffset
              timeSlot
            }
          }
        }
        suggestedAutopilotSettings {
          isRoomFlexible
          movementType
          allowedEndTime {
            dayOffset
            timeSlot
          }
          allowedStartTime {
            dayOffset
            timeSlot
          }
        }
      }
    }
    moveRangeInLocalTimeV3 {
      __typename
      ... on MoveRangeInLocalTimeV3 {
        allowedStartTimeInclusive {
          dayOffset
          timeSlot
        }
        allowedEndTimeInclusive {
          dayOffset
          timeSlot
        }
      }
    }
    featureStatesForOrganizer {
      __typename
      ... on FeatureStates {
        mixedFreemiumOrgUIState {
          autopilotPaused
          moveRangesEnabled
          quotaStatusBanner
        }
      }
      ... on GraphEntityError {
        statusCode
        message
      }
    }
  }
}

fragment Event_org on Org {
  ...AutopilotFormSaveOnEdit_org
  id
  ...EventSummary_org
  ...EventSmartHoldInfo_org
  ...EventTeam_org
  experiments
  domains
  primaryOrgCalendar
  primaryOrgEmail
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      enabled
      shadowCalendarId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          billingGroup {
            id
            invitePolicy
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment Event_smartHoldEventInfo on SmartHoldEventInfo {
  ...EventSmartHoldInfo_smartHoldEventInfo
  ...EventTeam_smartHoldEventInfo
  ...EventSummary_smartHoldEventInfo
}

fragment Event_user on User {
  emails
  id
  ...EventSummary_user
  ...EventSmartHoldInfo_user
  ...EventTeam_user
  ...AutopilotFormSaveOnEdit_user
}

fragment OrganizerAutopilotPausedFreemiumCallout_event on Event {
  eventParentRelayId
  organizer {
    urnValue
  }
}

fragment OrganizerAutopilotPausedFreemiumCallout_org on Org {
  id
  orgAccountingPeriod {
    __typename
    ... on OrgAccountingPeriod {
      periodRange {
        minDate
        maxDate
      }
      quotaMax
      quotaUsed
      enforcementState
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      stateMetadata {
        primaryBillingGroupMetadata {
          subscription {
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment PainOrPriorityEvent_org on Org {
  id
}

fragment TutorialTeamSharedCalendar_flagsErrorable on FlagsErrorable {
  __isFlagsErrorable: __typename
  __typename
  ... on Flags {
    flags
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "calendarIds"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalEventId"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "externalEventIds"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLinkedSmartHold"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isOnAPHistory"
    } as any, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v7 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "domains",
        "storageKey": null
    } as any, v12 = {
        "kind": "Variable",
        "name": "calendarIds",
        "variableName": "calendarIds"
    } as any, v13 = {
        "alias": null,
        "args": [
            (v12 /*: any*/),
            {
                "kind": "Variable",
                "name": "externalEventIds",
                "variableName": "externalEventIds"
            }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "canScheduleResponse",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CanScheduleResponse",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canAutopilot",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canReschedule",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "attendeeNotInDomain",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "organizerNotClockwiseUser",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isAllDayEvent",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "CanScheduleResponseList",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v14 = [
        (v12 /*: any*/)
    ], v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "none",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pending",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "synced",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stale",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shadowCalendarId",
        "storageKey": null
    } as any, v21 = {
        "kind": "Variable",
        "name": "calendarId",
        "variableName": "calendarId"
    } as any, v22 = {
        "kind": "Variable",
        "name": "externalEventId",
        "variableName": "externalEventId"
    } as any, v23 = [
        (v21 /*: any*/),
        (v22 /*: any*/)
    ], v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v25 = {
        "kind": "InlineFragment",
        "selections": [
            (v24 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any, v30 = [
        (v22 /*: any*/)
    ], v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v33 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v35 = [
        (v9 /*: any*/)
    ], v36 = {
        "kind": "InlineFragment",
        "selections": [
            (v24 /*: any*/),
            (v34 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v37 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v38 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v39 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetCalendarId",
            "storageKey": null
        } as any,
        (v9 /*: any*/)
    ], v40 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v41 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v42 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v43 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "list",
                "plural": true,
                "selections": [
                    (v9 /*: any*/),
                    (v40 /*: any*/),
                    (v41 /*: any*/),
                    (v42 /*: any*/),
                    (v43 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "type": "PersonList",
        "abstractKey": null
    } as any, v45 = {
        "kind": "InlineFragment",
        "selections": [
            (v34 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v46 = [
        (v8 /*: any*/),
        (v44 /*: any*/),
        (v45 /*: any*/)
    ], v47 = {
        "kind": "InlineFragment",
        "selections": (v35 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v48 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v49 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v50 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v51 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v8 /*: any*/),
                (v9 /*: any*/),
                (v48 /*: any*/),
                (v49 /*: any*/),
                (v43 /*: any*/),
                (v50 /*: any*/),
                (v42 /*: any*/)
            ],
            "storageKey": null
        } as any
    ], v52 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v53 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isClockwiseEvent",
        "storageKey": null
    } as any, v54 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transparency",
        "storageKey": null
    } as any, v55 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAllDay",
        "storageKey": null
    } as any, v56 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orgId",
        "storageKey": null
    } as any, v57 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v58 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectType",
        "storageKey": null
    } as any, v59 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectValue",
        "storageKey": null
    } as any, v60 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastModified",
        "storageKey": null
    } as any, v61 = [
        (v28 /*: any*/),
        (v58 /*: any*/),
        (v59 /*: any*/),
        (v60 /*: any*/),
        (v29 /*: any*/)
    ], v62 = {
        "alias": null,
        "args": null,
        "concreteType": "UserTag",
        "kind": "LinkedField",
        "name": "userTags",
        "plural": true,
        "selections": [
            (v57 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "TagState",
                "kind": "LinkedField",
                "name": "states",
                "plural": true,
                "selections": (v61 /*: any*/),
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v63 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateOrDateTime",
        "storageKey": null
    } as any, v64 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offsetMinutes",
        "storageKey": null
    } as any, v65 = [
        (v31 /*: any*/),
        (v63 /*: any*/),
        (v32 /*: any*/),
        (v37 /*: any*/),
        (v64 /*: any*/)
    ], v66 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v65 /*: any*/),
        "storageKey": null
    } as any, v67 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "eventFlexibilityErrorable",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventFlexibilityNew",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flex",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flexString",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "EventFlexibilityNewList",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v68 = {
        "alias": null,
        "args": null,
        "concreteType": "RecurrenceRules",
        "kind": "LinkedField",
        "name": "recurrenceRules",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "firstInstanceStartTime",
                "plural": false,
                "selections": (v65 /*: any*/),
                "storageKey": null
            },
            (v32 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "IntervalDefinition",
                "kind": "LinkedField",
                "name": "interval",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "interval",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "byDay",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bySetPos",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "freqType",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "untilTime",
                        "plural": false,
                        "selections": (v65 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v69 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any, v70 = {
        "alias": null,
        "args": [
            (v21 /*: any*/)
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "autopilotEventStatus",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    (v69 /*: any*/)
                ],
                "type": "AutopilotEventStatus",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any, v71 = {
        "alias": null,
        "args": null,
        "concreteType": "OrgTag",
        "kind": "LinkedField",
        "name": "orgTags",
        "plural": true,
        "selections": [
            (v57 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "TagState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                    (v29 /*: any*/),
                    (v28 /*: any*/),
                    (v58 /*: any*/),
                    (v59 /*: any*/),
                    (v60 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v72 = {
        "alias": null,
        "args": null,
        "concreteType": "AnnotatedEvent",
        "kind": "LinkedField",
        "name": "annotatedRecurringEvent",
        "plural": false,
        "selections": [
            (v71 /*: any*/),
            (v9 /*: any*/)
        ],
        "storageKey": null
    } as any, v73 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "autopilotPaused",
        "storageKey": null
    } as any, v74 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "moveRangesEnabled",
        "storageKey": null
    } as any, v75 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eventParentRelayId",
        "storageKey": null
    } as any, v76 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v77 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v76 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v76 /*: any*/),
            "storageKey": null
        } as any
    ], v78 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "suggestedAutopilotSettingsResponseV3",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DayOffsetTimeSlotRange",
                        "kind": "LinkedField",
                        "name": "intersectionOfAttendeesMeetingHours",
                        "plural": false,
                        "selections": (v77 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                        "kind": "LinkedField",
                        "name": "calendarIdToMeetingHours",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "calendarId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlotRange",
                                "kind": "LinkedField",
                                "name": "dayOffsetTimeSlotRanges",
                                "plural": true,
                                "selections": (v77 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedAutopilotSettingsV3",
                        "kind": "LinkedField",
                        "name": "suggestedAutopilotSettings",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRoomFlexible",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "movementType",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedEndTime",
                                "plural": false,
                                "selections": (v76 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DayOffsetTimeSlot",
                                "kind": "LinkedField",
                                "name": "allowedStartTime",
                                "plural": false,
                                "selections": (v76 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "SuggestedAutopilotSettingsResponseV3",
                "abstractKey": null
            },
            (v45 /*: any*/)
        ],
        "storageKey": null
    } as any, v79 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "moveRangeInLocalTimeV3",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DayOffsetTimeSlot",
                        "kind": "LinkedField",
                        "name": "allowedStartTimeInclusive",
                        "plural": false,
                        "selections": (v76 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DayOffsetTimeSlot",
                        "kind": "LinkedField",
                        "name": "allowedEndTimeInclusive",
                        "plural": false,
                        "selections": (v76 /*: any*/),
                        "storageKey": null
                    }
                ],
                "type": "MoveRangeInLocalTimeV3",
                "abstractKey": null
            },
            (v45 /*: any*/)
        ],
        "storageKey": null
    } as any, v80 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v81 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": [
            (v80 /*: any*/)
        ],
        "storageKey": null
    } as any, v82 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
    } as any, v83 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v84 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizer",
        "storageKey": null
    } as any, v85 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    } as any, v86 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "descriptionOmitted",
        "storageKey": null
    } as any, v87 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdMillis",
        "storageKey": null
    } as any, v88 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedMillis",
        "storageKey": null
    } as any, v89 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hangoutLink",
        "storageKey": null
    } as any, v90 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scrubbedEvent",
        "storageKey": null
    } as any, v91 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUser",
        "storageKey": null
    } as any, v92 = [
        (v37 /*: any*/),
        (v63 /*: any*/)
    ], v93 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flags",
                "storageKey": null
            }
        ],
        "type": "Flags",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v6 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "EventRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v7 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v8 /*: any*/),
                        (v9 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                (v13 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v14 /*: any*/),
                                    "concreteType": "CrawledCalendarInfo",
                                    "kind": "LinkedField",
                                    "name": "crawledCalendarInfoForCalendars",
                                    "plural": false,
                                    "selections": [
                                        (v15 /*: any*/),
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "shadowCalendarSettingsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v19 /*: any*/),
                                                (v20 /*: any*/)
                                            ],
                                            "type": "ShadowCalendarSettings",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v23 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "forceFetchEventParentErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        (v25 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v9 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventKey",
                                                            "kind": "LinkedField",
                                                            "name": "eventKey",
                                                            "plural": false,
                                                            "selections": [
                                                                (v26 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v27 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "AnnotatedEvent",
                                                            "kind": "LinkedField",
                                                            "name": "annotatedEvent",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "OrgTag",
                                                                    "kind": "LinkedField",
                                                                    "name": "orgTags",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TagState",
                                                                            "kind": "LinkedField",
                                                                            "name": "state",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v28 /*: any*/),
                                                                                (v29 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "args": [
                                                        (v21 /*: any*/),
                                                        {
                                                            "kind": "Variable",
                                                            "name": "isOnAPHistory",
                                                            "variableName": "isOnAPHistory"
                                                        }
                                                    ],
                                                    "kind": "FragmentSpread",
                                                    "name": "Event_eventParent"
                                                }
                                            ],
                                            "type": "EventParent",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "Event_org"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "PainOrPriorityEvent_org"
                                },
                                {
                                    "condition": "isLinkedSmartHold",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": (v30 /*: any*/),
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "smartHoldEventInfo",
                                            "plural": false,
                                            "selections": [
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "Event_smartHoldEventInfo"
                                                        }
                                                    ],
                                                    "type": "SmartHoldEventInfo",
                                                    "abstractKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "Event_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v6 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Operation",
            "name": "EventRendererQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v7 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v8 /*: any*/),
                        (v9 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v10 /*: any*/),
                                (v11 /*: any*/),
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "resolveOverrides",
                                            "value": false
                                        }
                                    ],
                                    "concreteType": "UserWorkingHours",
                                    "kind": "LinkedField",
                                    "name": "userWorkingHours",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingHours",
                                            "kind": "LinkedField",
                                            "name": "workingHours",
                                            "plural": false,
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v31 /*: any*/),
                                                (v32 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DaySetting",
                                                    "kind": "LinkedField",
                                                    "name": "daySettings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "day",
                                                            "storageKey": null
                                                        },
                                                        (v33 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DayOverride",
                                                    "kind": "LinkedField",
                                                    "name": "dayOverrides",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "date",
                                                            "storageKey": null
                                                        },
                                                        (v33 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": "userWorkingHours(resolveOverrides:false)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgAccountingPeriod",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DateRange",
                                                    "kind": "LinkedField",
                                                    "name": "periodRange",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "minDate",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "maxDate",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaMax",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "quotaUsed",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "enforcementState",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgAccountingPeriod",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v34 /*: any*/),
                                                (v24 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "featureGrid",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PaymentStateMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "stateMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PrimaryBillingGroupMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "primaryBillingGroupMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PaymentSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "subscription",
                                                                    "plural": false,
                                                                    "selections": (v35 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "BillingGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "billingGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "invitePolicy",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "FeatureGrid",
                                            "abstractKey": null
                                        },
                                        (v36 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "nextDefragTime",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v37 /*: any*/)
                                            ],
                                            "type": "DefragTime",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v38 /*: any*/),
                                    "concreteType": "SuggestedOrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SuggestedOrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedOrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v39 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "suggestedInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v38 /*: any*/),
                                    "concreteType": "OrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "pendingInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v39 /*: any*/),
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "pendingInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "userIds",
                                            "value": []
                                        }
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByUserIdsErrorable",
                                    "plural": false,
                                    "selections": (v46 /*: any*/),
                                    "storageKey": "personsByUserIdsErrorable(userIds:[])"
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "calendarIds",
                                            "value": []
                                        }
                                    ],
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personsByCalendarIdsErrorable",
                                    "plural": false,
                                    "selections": (v46 /*: any*/),
                                    "storageKey": "personsByCalendarIdsErrorable(calendarIds:[])"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "shadowCalendarSettingsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v20 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "focusTimeSyncAll",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "focusTimeIdealMinutesPerWeek",
                                                    "storageKey": null
                                                },
                                                (v19 /*: any*/)
                                            ],
                                            "type": "ShadowCalendarSettings",
                                            "abstractKey": null
                                        },
                                        (v47 /*: any*/),
                                        (v36 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "eventColoringSettingsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        (v36 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "EventCategoryColoring",
                                                    "kind": "LinkedField",
                                                    "name": "eventCategoryColorings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "googleColorKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "eventCategory",
                                                            "storageKey": null
                                                        },
                                                        (v29 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isUserSet",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "EventColoringSettings",
                                            "abstractKey": null
                                        },
                                        (v47 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "userTeams",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamCalendarId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                (v28 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "teamMembers",
                                                            "plural": true,
                                                            "selections": (v51 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "TeamMember",
                                                            "kind": "LinkedField",
                                                            "name": "invitedMembers",
                                                            "plural": true,
                                                            "selections": (v51 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "settings",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "manageTeamCalendar",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v47 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v38 /*: any*/),
                                    "concreteType": "GoalConnection",
                                    "kind": "LinkedField",
                                    "name": "userGoals",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Goal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "GoalOptions",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "specificOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "maxMinutesPerBlock",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "GoalWithinWeekOptions",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "minimumDuration",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "idealDuration",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "minTimeSlot",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "maxTimeSlot",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "GoalWithinDayOptions",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "userGoals(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgEmail",
                                    "storageKey": null
                                },
                                (v13 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v14 /*: any*/),
                                    "concreteType": "CrawledCalendarInfo",
                                    "kind": "LinkedField",
                                    "name": "crawledCalendarInfoForCalendars",
                                    "plural": false,
                                    "selections": [
                                        (v15 /*: any*/),
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        (v9 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v23 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "forceFetchEventParentErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        (v25 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v9 /*: any*/),
                                                (v26 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "syncedOriginEventErrorable",
                                                    "plural": false,
                                                    "selections": [
                                                        (v8 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v52 /*: any*/),
                                                                (v53 /*: any*/),
                                                                (v54 /*: any*/),
                                                                (v55 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventKey",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v56 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AnnotatedEvent",
                                                                    "kind": "LinkedField",
                                                                    "name": "annotatedEvent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v62 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgTag",
                                                                            "kind": "LinkedField",
                                                                            "name": "orgTags",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v57 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TagState",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "state",
                                                                                    "plural": false,
                                                                                    "selections": (v61 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "startTime",
                                                                    "plural": false,
                                                                    "selections": (v65 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                (v66 /*: any*/),
                                                                (v67 /*: any*/),
                                                                (v68 /*: any*/),
                                                                (v70 /*: any*/),
                                                                (v72 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "featureStatesForOrganizer",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "MixedFreemiumOrgUiState",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "mixedFreemiumOrgUIState",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v73 /*: any*/),
                                                                                        (v74 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "FeatureStates",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v36 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v75 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "attendeePeople",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        (v44 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v78 /*: any*/),
                                                                (v79 /*: any*/),
                                                                (v81 /*: any*/),
                                                                (v82 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Attendee",
                                                                    "kind": "LinkedField",
                                                                    "name": "attendees",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v83 /*: any*/),
                                                                        (v80 /*: any*/),
                                                                        (v84 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v85 /*: any*/),
                                                                (v86 /*: any*/),
                                                                (v87 /*: any*/),
                                                                (v88 /*: any*/),
                                                                (v89 /*: any*/),
                                                                (v90 /*: any*/)
                                                            ],
                                                            "type": "Event",
                                                            "abstractKey": null
                                                        },
                                                        (v36 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        (v75 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "attendeePeople",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Person",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v9 /*: any*/),
                                                                                (v40 /*: any*/),
                                                                                (v41 /*: any*/),
                                                                                (v42 /*: any*/),
                                                                                (v43 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v50 /*: any*/),
                                                                                (v91 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "PersonList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventKey",
                                                            "kind": "LinkedField",
                                                            "name": "eventKey",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v26 /*: any*/),
                                                                (v56 /*: any*/),
                                                                (v27 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "hashedCalendars",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "AnnotatedEvent",
                                                            "kind": "LinkedField",
                                                            "name": "annotatedEvent",
                                                            "plural": false,
                                                            "selections": [
                                                                (v71 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v62 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v72 /*: any*/),
                                                        (v78 /*: any*/),
                                                        (v79 /*: any*/),
                                                        (v81 /*: any*/),
                                                        (v70 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "featureStatesForOrganizer",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "MixedFreemiumOrgUiState",
                                                                            "kind": "LinkedField",
                                                                            "name": "mixedFreemiumOrgUIState",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v73 /*: any*/),
                                                                                (v74 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "quotaStatusBanner",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "FeatureStates",
                                                                    "abstractKey": null
                                                                },
                                                                (v36 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v52 /*: any*/),
                                                        (v55 /*: any*/),
                                                        (v82 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "startTime",
                                                            "plural": false,
                                                            "selections": [
                                                                (v63 /*: any*/),
                                                                (v37 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v32 /*: any*/),
                                                                (v64 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Attendee",
                                                            "kind": "LinkedField",
                                                            "name": "attendees",
                                                            "plural": true,
                                                            "selections": [
                                                                (v83 /*: any*/),
                                                                (v80 /*: any*/),
                                                                (v84 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "responseStatus",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v53 /*: any*/),
                                                        (v54 /*: any*/),
                                                        (v66 /*: any*/),
                                                        (v67 /*: any*/),
                                                        (v68 /*: any*/),
                                                        (v85 /*: any*/),
                                                        (v86 /*: any*/),
                                                        (v87 /*: any*/),
                                                        (v88 /*: any*/),
                                                        (v89 /*: any*/),
                                                        (v90 /*: any*/),
                                                        (v27 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "organizerPerson",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v40 /*: any*/),
                                                                        (v43 /*: any*/),
                                                                        (v41 /*: any*/),
                                                                        (v50 /*: any*/)
                                                                    ],
                                                                    "type": "Person",
                                                                    "abstractKey": null
                                                                },
                                                                (v47 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventAutopilotHistory",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v69 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "AutopilotHistoryActionLog",
                                                                            "kind": "LinkedField",
                                                                            "name": "actions",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "actionType",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "actionString",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "actionInfo",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "timestamp",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventAutopilotHistory",
                                                                    "abstractKey": null
                                                                },
                                                                (v45 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "organizerOrgPerson",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v43 /*: any*/),
                                                                        (v50 /*: any*/),
                                                                        (v48 /*: any*/),
                                                                        (v49 /*: any*/)
                                                                    ],
                                                                    "type": "OrgPerson",
                                                                    "abstractKey": null
                                                                },
                                                                (v47 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "EventParent",
                                            "abstractKey": null
                                        },
                                        (v47 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "condition": "isLinkedSmartHold",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": (v30 /*: any*/),
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "smartHoldEventInfo",
                                            "plural": false,
                                            "selections": [
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isPreTravelTime",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isPostTravelTime",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isMeetingPrep",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "originEvent",
                                                            "plural": false,
                                                            "selections": [
                                                                (v52 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventKey",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v26 /*: any*/),
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AnnotatedEvent",
                                                                    "kind": "LinkedField",
                                                                    "name": "annotatedEvent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UserTag",
                                                                            "kind": "LinkedField",
                                                                            "name": "userTags",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v57 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TagState",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "states",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v58 /*: any*/),
                                                                                        (v59 /*: any*/),
                                                                                        (v28 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v55 /*: any*/),
                                                                (v27 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Attendee",
                                                                    "kind": "LinkedField",
                                                                    "name": "organizer",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v83 /*: any*/),
                                                                        (v80 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "startTime",
                                                                    "plural": false,
                                                                    "selections": (v92 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "endTime",
                                                                    "plural": false,
                                                                    "selections": (v92 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "organizerPerson",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v41 /*: any*/),
                                                                                (v40 /*: any*/),
                                                                                (v43 /*: any*/),
                                                                                (v50 /*: any*/),
                                                                                (v91 /*: any*/),
                                                                                (v42 /*: any*/)
                                                                            ],
                                                                            "type": "Person",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v47 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isTeamCalendarSyncEvent",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "type": "SmartHoldEventInfo",
                                                    "abstractKey": null
                                                },
                                                (v47 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v40 /*: any*/),
                                (v9 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "webAppFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        (v36 /*: any*/),
                                        (v93 /*: any*/),
                                        (v47 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "chromeExtensionFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isFlagsErrorable"
                                        },
                                        (v93 /*: any*/),
                                        (v47 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v9 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "20c1796bea55ba6f72a5f74f75a38379",
            "id": null,
            "metadata": {},
            "name": "EventRendererQuery",
            "operationKind": "query",
            "text": "query EventRendererQuery(\n  $orgRelayId: ID!\n  $externalEventId: String!\n  $externalEventIds: [String!]!\n  $calendarId: String!\n  $calendarIds: [String!]!\n  $isLinkedSmartHold: Boolean!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      name\n      domains\n      ...Event_org\n      ...PainOrPriorityEvent_org\n      canScheduleResponse(externalEventIds: $externalEventIds, calendarIds: $calendarIds) {\n        __typename\n        ... on CanScheduleResponseList {\n          list {\n            canAutopilot\n            canReschedule\n            attendeeNotInDomain\n            organizerNotClockwiseUser\n            isAllDayEvent\n          }\n        }\n      }\n      crawledCalendarInfoForCalendars(calendarIds: $calendarIds) {\n        none\n        pending\n        synced\n        stale\n        id\n      }\n      smartHoldEventInfo(externalEventId: $externalEventId) @include(if: $isLinkedSmartHold) {\n        __typename\n        ... on SmartHoldEventInfo {\n          ...Event_smartHoldEventInfo\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      shadowCalendarSettingsErrorable {\n        __typename\n        ... on ShadowCalendarSettings {\n          enabled\n          shadowCalendarId\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      forceFetchEventParentErrorable(calendarId: $calendarId, externalEventId: $externalEventId) {\n        __typename\n        ... on GraphEntityError {\n          statusCode\n        }\n        ... on EventParent {\n          id\n          ...Event_eventParent_2wMSFq\n          events {\n            eventKey {\n              externalEventId\n              id\n            }\n            calendarIds\n            annotatedEvent {\n              orgTags {\n                state {\n                  value\n                  active\n                }\n              }\n              id\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  viewer {\n    user {\n      ...Event_user\n      id\n    }\n    id\n  }\n}\n\nfragment AutopilotEventHistory_event_3GsBW on Event {\n  eventAutopilotHistory {\n    __typename\n    ... on EventAutopilotHistory {\n      status\n      actions {\n        actionType\n        actionString\n        actionInfo\n        timestamp\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  organizer {\n    urnValue\n  }\n  title\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  startTime {\n    dateOrDateTime\n  }\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment AutopilotFlexibility_event on Event {\n  eventParentRelayId\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n  }\n  eventKey {\n    id\n    externalEventId\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFlexibility_org on Org {\n  userWorkingHours(resolveOverrides: false) {\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AutopilotFormSaveOnEdit_eventParent on EventParent {\n  id\n  externalEventId\n}\n\nfragment AutopilotFormSaveOnEdit_event_3GsBW on Event {\n  ...AutopilotForm_event_3GsBW\n  title\n  isAllDay\n  locked\n  eventKey {\n    externalEventId\n    id\n  }\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  startTime {\n    dateOrDateTime\n    millis\n  }\n  organizer {\n    urnValue\n  }\n  attendees {\n    displayName\n    urnValue\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFormSaveOnEdit_org on Org {\n  ...AutopilotForm_org\n  id\n  experiments\n  personsByUserIdsErrorable(userIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFormSaveOnEdit_org_2evVr4 on Org {\n  ...AutopilotForm_org\n  id\n  experiments\n  personsByUserIdsErrorable(userIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFormSaveOnEdit_user on User {\n  emails\n  webAppFlagsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Flags {\n      flags\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AutopilotForm_event_3GsBW on Event {\n  ...AutopilotFlexibility_event\n  ...OrganizerAutopilotPausedFreemiumCallout_event\n  eventParentRelayId\n  eventKey {\n    id\n    externalEventId\n  }\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n        moveRangesEnabled\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment AutopilotForm_org on Org {\n  ...AutopilotFlexibility_org\n  ...OrganizerAutopilotPausedFreemiumCallout_org\n  id\n  experiments\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        targetCalendarId\n        id\n      }\n    }\n  }\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment EventPeople_event on Event {\n  organizer {\n    urnValue\n  }\n  attendees {\n    organizer\n    urnValue\n    responseStatus\n  }\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        __typename\n        id\n        emails\n        primaryEmail\n        isYou\n        userId\n        isUser\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n  }\n}\n\nfragment EventPersonalCalendarInfo_eventParent_3GsBW on EventParent {\n  id\n  externalEventId\n  syncedOriginEventErrorable {\n    __typename\n    ... on Event {\n      __typename\n      title\n    }\n    ... on GraphEntityError {\n      __typename\n      statusCode\n      message\n    }\n  }\n}\n\nfragment EventSmartHoldInfo_event_3GsBW on Event {\n  ...EventSummary_event_3GsBW\n  title\n  isClockwiseEvent\n  organizer {\n    urnValue\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        subjectType\n        subjectValue\n        value\n        active\n      }\n    }\n    id\n  }\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n}\n\nfragment EventSmartHoldInfo_org on Org {\n  ...EventSummary_org\n  id\n  primaryOrgCalendar\n  primaryOrgEmail\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      shadowCalendarId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment EventSmartHoldInfo_smartHoldEventInfo on SmartHoldEventInfo {\n  isPreTravelTime\n  isPostTravelTime\n  isMeetingPrep\n  originEvent {\n    title\n    eventKey {\n      externalEventId\n      id\n    }\n    annotatedEvent {\n      userTags {\n        tag\n        states {\n          subjectType\n          subjectValue\n          value\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment EventSmartHoldInfo_user on User {\n  ...EventSummary_user\n}\n\nfragment EventSummaryAutopilot_event_3GsBW on Event {\n  autopilotEventStatus(calendarId: $calendarId) {\n    __typename\n    ... on AutopilotEventStatus {\n      status\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n        moveRangesEnabled\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment EventSummaryAutopilot_org on Org {\n  id\n  experiments\n}\n\nfragment EventSummaryColorCategory_event on Event {\n  title\n  isClockwiseEvent\n  transparency\n  isAllDay\n  eventKey {\n    id\n    externalEventId\n    orgId\n  }\n  annotatedEvent {\n    userTags {\n      tag\n      states {\n        value\n        subjectType\n        subjectValue\n        lastModified\n        active\n      }\n    }\n    orgTags {\n      tag\n      state {\n        value\n        subjectType\n        subjectValue\n        lastModified\n        active\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryColorCategory_org on Org {\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      shadowCalendarId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  id\n  experiments\n  eventColoringSettingsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on EventColoringSettings {\n      eventCategoryColorings {\n        googleColorKey\n        eventCategory\n        active\n        isUserSet\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment EventSummaryColorCategory_user on User {\n  id\n  webAppFlagsErrorable {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Flags {\n      flags\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment EventSummaryRecurrence_event on Event {\n  isAllDay\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryRecurrence_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummaryRoom_attendees on Attendee {\n  displayName\n  urnValue\n}\n\nfragment EventSummaryTime_event on Event {\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryTime_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummary_eventParent on EventParent {\n  ...AutopilotFormSaveOnEdit_eventParent\n}\n\nfragment EventSummary_event_3GsBW on Event {\n  ...EventSummaryColorCategory_event\n  ...EventSummaryRecurrence_event\n  ...EventSummaryTime_event\n  ...EventSummaryAutopilot_event_3GsBW\n  ...EventTimeAndRecurrence_event\n  ...AutopilotFormSaveOnEdit_event_3GsBW\n  title\n  isAllDay\n  description\n  descriptionOmitted\n  locked\n  isClockwiseEvent\n  createdMillis\n  updatedMillis\n  hangoutLink\n  scrubbedEvent\n  organizer {\n    urnValue\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        subjectType\n        subjectValue\n        value\n        active\n      }\n    }\n    id\n  }\n  attendees {\n    ...EventSummaryRoom_attendees\n    organizer\n    displayName\n    urnValue\n  }\n  startTime {\n    millis\n  }\n  endTime {\n    millis\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n}\n\nfragment EventSummary_org on Org {\n  ...EventSummaryAutopilot_org\n  ...EventSummaryColorCategory_org\n  ...EventSummaryRecurrence_org\n  ...EventSummaryTime_org\n  ...EventTimeAndRecurrence_org\n  ...AutopilotFormSaveOnEdit_org_2evVr4\n  id\n  experiments\n  primaryOrgCalendar\n  nextDefragTime {\n    __typename\n    ... on DefragTime {\n      millis\n    }\n  }\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      focusTimeSyncAll\n      focusTimeIdealMinutesPerWeek\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamCalendarId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamMembers {\n          person {\n            __typename\n            id\n            personId\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        invitedMembers {\n          person {\n            __typename\n            id\n            personId\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n      }\n    }\n  }\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        name\n        options {\n          specificOptions {\n            __typename\n            ... on GoalWithinWeekOptions {\n              maxMinutesPerBlock\n            }\n            ... on GoalWithinDayOptions {\n              minimumDuration\n              idealDuration\n              minTimeSlot\n              maxTimeSlot\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventSummary_smartHoldEventInfo on SmartHoldEventInfo {\n  isPreTravelTime\n  isPostTravelTime\n  originEvent {\n    title\n    eventKey {\n      externalEventId\n      id\n    }\n  }\n}\n\nfragment EventSummary_user on User {\n  ...EventSummaryColorCategory_user\n  ...AutopilotFormSaveOnEdit_user\n  emails\n}\n\nfragment EventTeam_eventParent_3GsBW on EventParent {\n  id\n  externalEventId\n  events {\n    ...AutopilotFormSaveOnEdit_event_3GsBW\n    ...EventSummary_event_3GsBW\n    ...EventSmartHoldInfo_event_3GsBW\n    ...EventPeople_event\n    ...EventSummaryTime_event\n    calendarIds\n    isAllDay\n    isClockwiseEvent\n    locked\n    organizerPerson {\n      __typename\n      ... on Person {\n        emails\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    annotatedEvent {\n      userTags {\n        tag\n        states {\n          value\n          subjectType\n          subjectValue\n          lastModified\n          active\n        }\n      }\n      orgTags {\n        tag\n        state {\n          subjectType\n          subjectValue\n          value\n          active\n        }\n      }\n      id\n    }\n    eventKey {\n      id\n      calendarIds\n      externalEventId\n      hashedCalendars\n      orgId\n    }\n    startTime {\n      millis\n      dateOrDateTime\n      timeZone\n    }\n    endTime {\n      millis\n    }\n    title\n    attendees {\n      displayName\n      urnValue\n    }\n    organizer {\n      urnValue\n    }\n  }\n}\n\nfragment EventTeam_org on Org {\n  id\n  ...EventSummaryTime_org\n  experiments\n  domains\n  primaryOrgCalendar\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamCalendarId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        invitedMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventTeam_smartHoldEventInfo on SmartHoldEventInfo {\n  isTeamCalendarSyncEvent\n  originEvent {\n    title\n    isAllDay\n    calendarIds\n    eventKey {\n      externalEventId\n      id\n    }\n    organizer {\n      displayName\n      urnValue\n    }\n    startTime {\n      millis\n      dateOrDateTime\n    }\n    endTime {\n      millis\n      dateOrDateTime\n    }\n    organizerPerson {\n      __typename\n      ... on Person {\n        __typename\n        primaryEmail\n        emails\n        isYou\n        userId\n        isUser\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment EventTeam_user on User {\n  chromeExtensionFlagsErrorable {\n    __typename\n    ...TutorialTeamSharedCalendar_flagsErrorable\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment EventTimeAndRecurrence_event on Event {\n  isAllDay\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventTimeAndRecurrence_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment Event_eventParent_2wMSFq on EventParent {\n  id\n  externalEventId\n  ...EventPersonalCalendarInfo_eventParent_3GsBW\n  ...AutopilotFormSaveOnEdit_eventParent\n  ...EventTeam_eventParent_3GsBW\n  ...EventSummary_eventParent\n  syncedOriginEventErrorable {\n    __typename\n    ... on Event {\n      ...EventSummary_event_3GsBW\n      title\n      description\n      descriptionOmitted\n      locked\n      isAllDay\n      isClockwiseEvent\n      createdMillis\n      updatedMillis\n      hangoutLink\n      organizer {\n        urnValue\n      }\n      eventKey {\n        externalEventId\n        id\n      }\n      annotatedEvent {\n        orgTags {\n          tag\n          state {\n            subjectType\n            subjectValue\n            value\n          }\n        }\n        id\n      }\n      attendees {\n        ...EventSummaryRoom_attendees\n        organizer\n        displayName\n        urnValue\n      }\n      startTime {\n        millis\n      }\n      endTime {\n        millis\n      }\n      recurrenceRules {\n        firstInstanceStartTime {\n          type\n          dateOrDateTime\n          timeZone\n          millis\n          offsetMinutes\n        }\n        timeZone\n        interval {\n          interval\n          byDay\n          bySetPos\n          freqType\n          count\n          untilTime {\n            type\n            dateOrDateTime\n            timeZone\n            millis\n            offsetMinutes\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  events {\n    ...AutopilotFormSaveOnEdit_event_3GsBW\n    ...EventSummary_event_3GsBW\n    ...EventSmartHoldInfo_event_3GsBW\n    ...EventPeople_event\n    ...AutopilotEventHistory_event_3GsBW\n    calendarIds\n    isAllDay\n    isClockwiseEvent\n    locked\n    scrubbedEvent\n    organizerPerson {\n      __typename\n      ... on Person {\n        emails\n        isYou\n        primaryEmail\n        userId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    organizerOrgPerson {\n      __typename\n      ... on OrgPerson {\n        isYou\n        userId\n        personId\n        primaryCalendarId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    annotatedEvent {\n      userTags {\n        tag\n        states {\n          value\n          subjectType\n          subjectValue\n          lastModified\n          active\n        }\n      }\n      orgTags {\n        tag\n        state {\n          subjectType\n          subjectValue\n          value\n          active\n        }\n      }\n      id\n    }\n    eventKey {\n      id\n      calendarIds\n      externalEventId\n      hashedCalendars\n      orgId\n    }\n    startTime {\n      millis\n      dateOrDateTime\n      timeZone\n    }\n    endTime {\n      millis\n    }\n    title\n    attendees {\n      displayName\n      urnValue\n    }\n    organizer {\n      urnValue\n    }\n    attendeePeople {\n      __typename\n      ... on PersonList {\n        list {\n          id\n          emails\n          primaryEmail\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n          isYou\n        }\n      }\n    }\n    recurrenceRules {\n      timeZone\n    }\n    suggestedAutopilotSettingsResponseV3 {\n      __typename\n      ... on SuggestedAutopilotSettingsResponseV3 {\n        intersectionOfAttendeesMeetingHours {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n        calendarIdToMeetingHours {\n          calendarId\n          dayOffsetTimeSlotRanges {\n            minSlot {\n              dayOffset\n              timeSlot\n            }\n            maxSlot {\n              dayOffset\n              timeSlot\n            }\n          }\n        }\n        suggestedAutopilotSettings {\n          isRoomFlexible\n          movementType\n          allowedEndTime {\n            dayOffset\n            timeSlot\n          }\n          allowedStartTime {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n    }\n    moveRangeInLocalTimeV3 {\n      __typename\n      ... on MoveRangeInLocalTimeV3 {\n        allowedStartTimeInclusive {\n          dayOffset\n          timeSlot\n        }\n        allowedEndTimeInclusive {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    featureStatesForOrganizer {\n      __typename\n      ... on FeatureStates {\n        mixedFreemiumOrgUIState {\n          autopilotPaused\n          moveRangesEnabled\n          quotaStatusBanner\n        }\n      }\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n    }\n  }\n}\n\nfragment Event_org on Org {\n  ...AutopilotFormSaveOnEdit_org\n  id\n  ...EventSummary_org\n  ...EventSmartHoldInfo_org\n  ...EventTeam_org\n  experiments\n  domains\n  primaryOrgCalendar\n  primaryOrgEmail\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      enabled\n      shadowCalendarId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          billingGroup {\n            id\n            invitePolicy\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment Event_smartHoldEventInfo on SmartHoldEventInfo {\n  ...EventSmartHoldInfo_smartHoldEventInfo\n  ...EventTeam_smartHoldEventInfo\n  ...EventSummary_smartHoldEventInfo\n}\n\nfragment Event_user on User {\n  emails\n  id\n  ...EventSummary_user\n  ...EventSmartHoldInfo_user\n  ...EventTeam_user\n  ...AutopilotFormSaveOnEdit_user\n}\n\nfragment OrganizerAutopilotPausedFreemiumCallout_event on Event {\n  eventParentRelayId\n  organizer {\n    urnValue\n  }\n}\n\nfragment OrganizerAutopilotPausedFreemiumCallout_org on Org {\n  id\n  orgAccountingPeriod {\n    __typename\n    ... on OrgAccountingPeriod {\n      periodRange {\n        minDate\n        maxDate\n      }\n      quotaMax\n      quotaUsed\n      enforcementState\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment PainOrPriorityEvent_org on Org {\n  id\n}\n\nfragment TutorialTeamSharedCalendar_flagsErrorable on FlagsErrorable {\n  __isFlagsErrorable: __typename\n  __typename\n  ... on Flags {\n    flags\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '51b0b65a6ca5fe64b59d2566ee9c8fe6';
export default node;
